import { HTMLAttributes } from 'react'

import { cn, VStack } from '@podo-app/design-system-temp'

export const ContentSection = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <VStack className={cn('p-5 w-full', className)} {...props}>
      {props.children}
    </VStack>
  )
}
